export const sitecoreMediaSrc = (src?: string): string | undefined => {
  if (!src) {
    return src;
  }
  if (src.startsWith('/-/media') || src.startsWith('/-/jssmedia')) {
    return src;
  }
  try {
    const parsedSrc = new URL(src);
    if (parsedSrc.pathname.startsWith('/-/media') || parsedSrc.pathname.startsWith('/-/jssmedia')) {
      return `${parsedSrc.pathname}${parsedSrc.search}`;
    }
  } catch {
    const mediaIndex = src.indexOf('/-/media');
    const jssMediaIndex = src.indexOf('/-/jssmedia');
    const pathIndex = mediaIndex >= 0 ? mediaIndex : jssMediaIndex;
    if (pathIndex >= 0) {
      return src.substring(pathIndex);
    }
  }
  return src;
};
export const sitecoreMediaInRichText = (content?: string): string | undefined => {
  if (!content) {
    return content;
  }
  return content.replace(/(src|href)\s*=\s*(["'])(.*?)\2/gi, (match, attr, quote, url) => {
    const normalizedUrl = sitecoreMediaSrc(url);
    if (!normalizedUrl || normalizedUrl === url) {
      return match;
    }
    return `${attr}=${quote}${normalizedUrl}${quote}`;
  });
};
